import { AjvError } from "@rjsf/core"

/**
 * Forces focus on field input by schema property path
 * @param property - property path on schema eg. ".firstname" or ".sub_form.firstname"
 */
export const focusOnField = (property: string) => {
    if (!property || typeof property !== "string") return
    let uniqueClassName = "root_" + property; //  property.replace(/^\./g, "root_");
    let fieldElement = document.getElementsByClassName(uniqueClassName)[0];

    if (!fieldElement) {
        fieldElement = document.querySelectorAll(".field.error")[0];
    }

    if (fieldElement) {
        const inputElement = fieldElement.querySelectorAll("INPUT, SELECT, TEXTAREA,  [tabindex]:not([tabindex=\"-1\"])")[0] as HTMLInputElement | undefined;

        inputElement && inputElement.focus();
    }
}


export function transformErrors(errors: AjvError[]): AjvError[] {
    return errors.map(error => {
        if (error.name === "required") {
            error.message = "Pakollinen kenttä"
        }

        if (error.name === "maxLength") {
            error.message = `Ei tulisi olla pidempi kuin ${error.params.limit} merkkiä`
        }

        if (error.name === "minLength") {
            error.message = `Ei tulisi olla lyhyempi kuin ${error.params.limit} merkkiä`
        }

        if (error.name === "minItems") {
            error.message = `Valitse vähintään ${error.params.limit}`
        }

        if (error.name === "maxItems") {
            error.message = `Valitse enintään ${error.params.limit}`
        }


        if (error.name === "format") {

            if (error.params.format === "date-time") {
                error.message = "Päivämäärän tulee olla muodossa pp.kk.vvvv HH:mm"
            }
            if (error.params.format === "time") {
                error.message = "Kellonaika ei ole okeassa muodossa"
            }
            if (error.params.format === "date") {
                error.message = "Päivämäärän tulee olla muodossa pp.kk.vvvv"
            }
        }



        return error;
    });
}